import { render, staticRenderFns } from "./Standings2021.vue?vue&type=template&id=ee6d66b8&"
import script from "./Standings2021.vue?vue&type=script&lang=js&"
export * from "./Standings2021.vue?vue&type=script&lang=js&"
import style0 from "./Standings2021.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports